import React from 'react';

import styles from './style.scss';


const BookListItemEmpty = () => (
  <div className={styles.content}>
    <div>
      <div className={styles.author}>
        <div className={styles.authorImage} />
        <p className={styles.authorText} />
      </div>
      <div className={styles.rating} />
    </div>
    <div className={styles.text} />
    <div className={styles.text} />
    <div className={styles.rating} />
    <div className={styles.text} />
    <div>
      <div className={styles.date} />
    </div>
  </div>
);

export default BookListItemEmpty;
